import { render, staticRenderFns } from "./CartCard.vue?vue&type=template&id=51f5fed8&scoped=true"
import script from "./CartCard.vue?vue&type=script&lang=ts"
export * from "./CartCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f5fed8",
  null
  
)

export default component.exports